module.exports = __webpack_public_path__ + "assets/img/B.d133ddc0.png";